//region :: imports ::
import {ReactElement} from 'react';
import MComponent from '../Component';
import {classNames} from 'primereact/utils';

//endregion

/** */
type Props = {
    title: string;
    hasTopMargin?: boolean;
}

/** */
class MFormSeparator extends MComponent<Props> {

    /** */
    public render(): ReactElement {

        return (
            <div className={classNames('mb-3 text-2xl font-light uppercase')}>
                {this.props.title}
            </div>
        );

    }

}

export default MFormSeparator;
